export function getView(steps, currentIdx) {
  return steps.length - 1 === currentIdx
}
